// api.service.ts

import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class ApiV1Service {
  constructor(private http: HttpClient) {}

  private getHeaders(headers?: { [key: string]: string }): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      ...headers,
    });
  }

  public get<T>(
    path: string,
    headers?: { [key: string]: string },
  ): Observable<T> {
    const url = `${environment.serverV1Url}${path}`;
    const updatedHeaders = this.getHeaders(headers);
    return this.http.get<T>(url, { headers: updatedHeaders }).pipe(
      catchError((error) => {
        console.error('API Error:', error);
        return throwError(() => error);
      }),
    );
  }

  public post<T>(
    path: string,
    body: any,
    headers?: { [key: string]: string },
  ): Observable<T> {
    const url = `${environment.serverV1Url}${path}`;
    const updatedHeaders = this.getHeaders(headers);

    return this.http.post<T>(url, body, { headers: updatedHeaders }).pipe(
      catchError((error) => {
        console.error('API Error:', error);
        return throwError(() => error);
      }),
    );
  }

  public postWithCredentials<T>(
    path: string,
    body: any,
    headers?: { [key: string]: string },
  ): Observable<T> {
    const url = `${environment.serverV1Url}${path}`;
    const updatedHeaders = this.getHeaders(headers);

    return this.http
      .post<T>(url, body, { headers: updatedHeaders, withCredentials: true })
      .pipe(
        catchError((error) => {
          console.error('API Error:', error);
          return throwError(() => error);
        }),
      );
  }

  public put<T>(
    path: string,
    body: any,
    headers?: { [key: string]: string },
  ): Observable<T> {
    const url = `${environment.serverV1Url}${path}`;
    const updatedHeaders = this.getHeaders(headers);

    return this.http.put<T>(url, body, { headers: updatedHeaders }).pipe(
      catchError((error) => {
        console.error('API Error:', error);
        return throwError(() => error);
      }),
    );
  }

  public delete<T>(
    path: string,
    headers?: { [key: string]: string },
  ): Observable<T> {
    const url = `${environment.serverV1Url}${path}`;
    const updatedHeaders = this.getHeaders(headers);

    return this.http.delete<T>(url, { headers: updatedHeaders }).pipe(
      catchError((error) => {
        console.error('API Error:', error);
        return throwError(() => error);
      }),
    );
  }

  public patch<T>(
    path: string,
    body: any,
    headers?: { [key: string]: string },
  ): Observable<T> {
    const url = `${environment.serverV1Url}${path}`;
    const updatedHeaders = this.getHeaders(headers);

    return this.http.patch<T>(url, body, { headers: updatedHeaders }).pipe(
      catchError((error) => {
        console.error('API Error:', error);
        return throwError(() => error);
      }),
    );
  }
}
